import { render, staticRenderFns } from "./SecretarysRegister.vue?vue&type=template&id=7032e7d8&"
import script from "./SecretarysRegister.vue?vue&type=script&lang=js&"
export * from "./SecretarysRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports